import api from '../../utils/api';

const API_BASE_URL = "/admin/ADPRefcode"; // Adjust to match your backend API

const ADPMenuService = {
    async findAll(): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`);
        return response.data;
    },

    async getItemById(moduleId: any, referenceGroup: any): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${moduleId}/${referenceGroup}`);
        return response.data;
    },

    async create(item: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, item);
        return response.data;
    },

    async update(moduleId: any, referenceGroup: any, item: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${moduleId}/${referenceGroup}`, item);
        return response.data;
    },

    async delete(moduleId: any, referenceGroup: any, item: any): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${moduleId}/${referenceGroup}`);
        return response.data;
    },

    async getDropdown(): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/get-dropdown`);
        return response.data;
    },

    async getDropdownByModuleIdAndReferencegroup(moduleId: any, referenceGroup: any): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/get-dropdown-by-module-id-reference-group/${moduleId}/${referenceGroup}`);
        return response.data;
    },

    async getItemByModuleIdAndReferencegroup(moduleId: any, referenceGroup: any): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/get-item-by-module-id-reference-group/${moduleId}/${referenceGroup}`);
        return response.data;
    },
    async getDropdownByModuleIdAndReferencegroupAndValue1(moduleId: any, referenceGroup: any, value1: any): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/get-dropdown-by-module-id-reference-group-value1/${moduleId}/${referenceGroup}/${value1}`);
        return response.data;
    },
};



export default ADPMenuService;